import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMapPin, FiCalendar, FiClock, FiUsers } = FiIcons;

const PriceSection = () => {
  return (
    <section className="py-20 px-4 relative">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-pink-900/10 to-transparent"></div>
      
      <div className="relative z-10 max-w-6xl mx-auto">
        <motion.div
          initial={{ y: 30, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            <span className="bg-gradient-to-r from-pink-400 to-red-400 bg-clip-text text-transparent">
              THE PRICE & OFFER
            </span>
          </h2>
          
          <h3 className="text-2xl md:text-3xl font-semibold text-white">
            ราคาที่คุณจ่าย... ถูกกว่าค่าทนายเวลาฟ้องหย่า หรือค่าเสียหายเวลาโดนโกง
          </h3>
        </motion.div>

        <div className="max-w-4xl mx-auto">
          {/* Main Course Info */}
          <motion.div
            initial={{ y: 50, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="bg-slate-800/50 backdrop-blur-sm border border-pink-500/30 rounded-2xl p-8 mb-12"
          >
            <h4 className="text-3xl font-bold text-white text-center mb-8">
              หลักสูตรเจาะลึก 2 วันเต็ม (Bazi Love & Relationships)
            </h4>
            
            <div className="grid md:grid-cols-2 gap-8 mb-8">
              <div className="text-center">
                <div className="text-2xl font-bold text-gray-300 line-through mb-2">
                  ราคาเต็ม ~~12,500 บาท~~
                </div>
              </div>
              
              <div className="text-center">
                <div className="text-4xl font-bold text-pink-400 mb-2">
                  🔥 โปรโมชั่นพิเศษ: เพียง 9,900 บาท
                </div>
              </div>
            </div>
            
            <div className="bg-gradient-to-r from-pink-500/20 to-red-500/20 rounded-xl p-4 text-center">
              <p className="text-lg text-white font-semibold">
                เฉพาะ 20 ท่านแรก หรือก่อนปรับราคา
              </p>
            </div>
          </motion.div>

          {/* Course Details */}
          <motion.div
            initial={{ y: 50, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
            className="grid md:grid-cols-2 gap-8 mb-12"
          >
            <div className="bg-slate-800/50 backdrop-blur-sm border border-slate-700/50 rounded-2xl p-6">
              <div className="flex items-center mb-4">
                <SafeIcon icon={FiCalendar} className="text-2xl text-pink-400 mr-3" />
                <h5 className="text-xl font-bold text-white">วันเรียน</h5>
              </div>
              <p className="text-lg text-gray-300 mb-2">📅 21-22 กุมภาพันธ์ 2569</p>
              <p className="text-gray-400">(เสาร์-อาทิตย์)</p>
            </div>
            
            <div className="bg-slate-800/50 backdrop-blur-sm border border-slate-700/50 rounded-2xl p-6">
              <div className="flex items-center mb-4">
                <SafeIcon icon={FiMapPin} className="text-2xl text-pink-400 mr-3" />
                <h5 className="text-xl font-bold text-white">สถานที่</h5>
              </div>
              <p className="text-lg text-gray-300 mb-2">📍 โรงแรมมาตรฐาน กรุงเทพฯ</p>
              <p className="text-gray-400">(รายละเอียดจะแจ้งหลังสมัคร)</p>
            </div>
          </motion.div>

          {/* Call to Action */}
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            whileInView={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            viewport={{ once: true }}
            className="text-center"
          >
            <div className="bg-gradient-to-r from-pink-500/20 to-red-500/20 backdrop-blur-sm border border-pink-500/30 rounded-2xl p-8">
              <h4 className="text-2xl md:text-3xl font-bold text-white mb-6">
                อ่านคนขาด... ชนะทุกเกมความสัมพันธ์
              </h4>
              
              <p className="text-lg text-gray-300 mb-8">
                ที่นั่งมีจำกัด (เน้นสอนเจาะลึกดูแลทั่วถึง)
              </p>
              
              <button className="group relative px-10 py-5 bg-gradient-to-r from-pink-500 to-red-600 text-white font-bold text-xl rounded-full shadow-2xl hover:shadow-pink-500/25 transition-all duration-300 transform hover:scale-105 border border-pink-400/50 mb-4">
                <span>🔥 สมัครทันที! Bazi Love & Relationships</span>
                <div className="absolute inset-0 bg-gradient-to-r from-pink-600 to-red-700 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300 -z-10"></div>
              </button>
              
              <p className="text-pink-300 font-semibold text-lg">
                ราคาพิเศษ 9,900.-
              </p>
              
              <div className="mt-6 flex items-center justify-center space-x-6 text-gray-300">
                <div className="flex items-center">
                  <SafeIcon icon={FiUsers} className="text-pink-400 mr-2" />
                  <span>จำกัด 20 ที่นั่ง</span>
                </div>
                
                <div className="flex items-center">
                  <SafeIcon icon={FiClock} className="text-pink-400 mr-2" />
                  <span>2 วันเต็ม</span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default PriceSection;